export default {
  tree: [
    {
      key: "theme",
      folder: true,
      title: "test-site",
      children: [
        {
          key: "assets",
          secure_random: "assets",
          folder: true,
          title: "assets",
          reference: null,
          file_type: "asset",
          path: "assets",
          tephra: null,
          folder_or_file: "assets",
          created_at: null,
          updated_at: null,
          children: [
            {
              key: "fonts",
              secure_random: "fonts",
              folder: true,
              title: "fonts",
              reference: null,
              file_type: "asset",
              path: "assets/fonts",
              tephra: null,
              folder_or_file: "fonts",
              created_at: null,
              updated_at: null,
              extraClasses: "root-folder image-upload",
              child_of: "assets"
            },
            {
              key: "images",
              secure_random: "images",
              folder: true,
              title: "images",
              reference: null,
              file_type: "asset",
              path: "assets/images",
              tephra: null,
              folder_or_file: "images",
              created_at: null,
              updated_at: null,
              extraClasses: "root-folder image-upload",
              child_of: "assets"
            },
            {
              key: "javascripts",
              secure_random: "javascripts",
              folder: true,
              title: "javascripts",
              reference: null,
              file_type: "asset",
              path: "assets/javascripts",
              tephra: null,
              folder_or_file: "javascripts",
              created_at: null,
              updated_at: null,
              extraClasses: "root-folder",
              child_of: "assets"
            },
            {
              key: "stylesheets",
              secure_random: "stylesheets",
              folder: true,
              title: "stylesheets",
              reference: null,
              file_type: "asset",
              path: "assets/stylesheets",
              tephra: null,
              folder_or_file: "stylesheets",
              created_at: null,
              updated_at: null,
              extraClasses: "root-folder",
              child_of: "assets"
            }
          ],
          extraClasses: "root-folder",
          child_of: "test-site"
        },
        {
          key: "layouts",
          secure_random: "layouts",
          folder: true,
          title: "layouts",
          reference: null,
          file_type: "layout",
          path: "layouts",
          tephra: null,
          folder_or_file: "layouts",
          created_at: null,
          updated_at: null,
          extraClasses: "root-folder",
          child_of: "test-site"
        },
        {
          key: "templates",
          secure_random: "templates",
          folder: true,
          title: "templates",
          reference: null,
          file_type: "template",
          path: "templates",
          tephra: null,
          folder_or_file: "templates",
          created_at: null,
          updated_at: null,
          extraClasses: "root-folder",
          child_of: "test-site"
        },
        {
          key: "snippets",
          secure_random: "snippets",
          folder: true,
          title: "snippets",
          reference: null,
          file_type: "snippet",
          path: "snippets",
          tephra: null,
          folder_or_file: "snippets",
          created_at: null,
          updated_at: null,
          extraClasses: "root-folder",
          child_of: "test-site"
        }
      ],
      extraClasses: "theme",
      data: {
        integrity: false,
        secure_random_integrity: false
      }
    }
  ]
}
